/*============share Controller
 ================================*/
angular
  .module('vppApp')
  .controller('shareController', shareController);

shareController.$inject = ['$scope', 'apiFactory'];

function shareController($scope, apiFactory) {

  apiFactory.getSsoUrl().then(function (response) {
    $scope.ssoUrl = response.data;
  });

}